import StaticRenderer from "SlidesRenderer/StaticRenderer";

export default function ScreenshotSlidePage() {
  console.warn(
    "This page has been deprecated and may be removed in the future."
  );
  return <StaticRenderer />;
}
